import styles from './Join.module.scss';
import loginBack from '../../assets/loginBack.png';
import { isDesktop } from 'react-device-detect';
import Header from '../../components/Header/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axiosClient from '../../libs/axiosClient';
import { setToken } from '../../auth/auth';
import inputCancel from '../../assets/inputCancel.png';
import selectOpen from '../../assets/selectOpen.png';
import JoinAgreementModal from '../../components/JoinAgreementModal/JoinAgreementModal';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import apple from '../../assets/appleLogo.png';
import facebook from '../../assets/facebookLogo.png';
import google from '../../assets/googleLogo.png';
import { handleRedirectUrlCheck } from '../../common/redirectUrlCheck';
import { handleAppleLogin } from '../../auth/Apple';
import { FACEBOOK_AUTH_URL } from '../../auth/Facebook';
import { GOOGLE_AUTH_URL } from '../../auth/Google';

interface ClientConfig {
  clientId: string;
  redirectURI: string;
  scope?: string;
  state?: string;
  nonce?: string;
  usePopup?: boolean;
}

interface Authorization {
  code: string;
  id_token: string;
  state?: string;
}

interface User {
  email: string;
  name: {
    firstName: string;
    lastName: string;
  };
}

interface SigninResponse {
  authorization: Authorization;
  user?: User;
}

interface SigninError {
  error: string;
}

declare global {
  interface Window {
    AppleID: {
      auth: {
        init: (config: ClientConfig) => void;
        signIn: (config?: ClientConfig) => Promise<SigninResponse>;
      };
    };
  }
}

export function checkTel(tel: string) {
  for (let i = 0; i < tel.length; i++) {
    if (isNaN(Number(tel[i]))) return false;
  }
  if (tel.length < 12) return false;
  else return true;
}
const idRegex = /^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z]{4,30}$/;
var passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d~!@#$%^&*()+|=]{8,30}$/;
const nameRegex = /^[ㄱ-ㅎ가-힣a-zA-Z\s]+$/;
const emailRegex =
  /^([\w\.\_\-])*[a-zA-Z0-9]+([\w\.\_\-])*([a-zA-Z0-9])+([\w\.\_\-])+@([a-zA-Z0-9]+\.)+[a-zA-Z0-9]{2,8}$/;
const telRegex = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

function Join() {
  const navigate = useNavigate();
  const [emailDirectly, setEmailDirectly] = useState(false);
  const location = useLocation();
  let redirectURL = new URLSearchParams(location.search).get('rurl');

  function marketingAgree(idx: number) {
    if (idx == 0 || idx == 1) {
      setValue(
        'marketing',
        (() => {
          let newVal = watch().marketing;
          newVal[idx] = !newVal[idx];
          return [newVal[0], newVal[1], false];
        })(),
      );
    } else setValue('marketing', [false, false, !watch().marketing[2]]);
  }
  function handleIdCheck() {
    if (!idRegex.test(watch().id)) {
      alert(t('join.41'));
      return;
    }
    axiosClient
      .get(`/data/verification/id?id=${watch().id}`)
      .then((res) => {
        setValue('idCheck', true);
        alert(t('join.42'));
      })
      .catch((err) => alert(err.response.data.detail || t('join.43')));
  }
  function handleEmailCheck() {
    if (!emailRegex.test(watch().email1 + '@' + watch().email2)) {
      alert(t('join.44'));
      return;
    }
    axiosClient
      .get(
        `/data/verification/email?email=${
          watch().email1 + '@' + watch().email2
        }`,
      )
      .then((res) => {
        setValue('emailCheck', true);
        alert(t('join.45'));
      })
      .catch((err) => alert(err.response.data.detail));
  }
  const [agreementModalOpen, setAgreementModalOpen] = useState(false);
  const [agreementModalType, setAgreementModalType] = useState(0);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm();
  const onSubmit = (data: any) => {
    let formData = new FormData();
    formData.append('individual_id', data.id);
    formData.append('password', data.pw);
    formData.append('name', data.name);
    formData.append('email', data.email1 + '@' + data.email2);
    formData.append('phone', data.tel);
    formData.append('agree_privacy', 'Y');
    formData.append('agree_terms', 'Y');
    formData.append('member_role_id', '2');
    formData.append('accept_sms', data.marketing[0] ? 'Y' : 'N');
    formData.append('accept_email', data.marketing[1] ? 'Y' : 'N');
    formData.append('birthyear', data.birthYear);
    formData.append('birthday', data.birthDay);

    if (data.gender === 'male') {
      formData.append('gender', 'M');
    } else if (data.gender === 'female') {
      formData.append('gender', 'F');
    } else {
      formData.append('gender', 'N');
    }

    axiosClient
      .post('/func/user/registration', formData, {
        headers: {
          'Access-Control-Allow-Origin': 'https://api.us.dietdr.co.kr',
        },
        withCredentials: true,
      })
      .then((res) => {
        setToken(res.data);
        if (handleRedirectUrlCheck(redirectURL || '/'))
          navigate(redirectURL || '/');
        else navigate('/joinSuccess');
        // navigate('/joinSuccess');
        return true;
      })
      .catch((err) => {
        if (err.response.status == 409) {
          alert(t('join.46'));
          return false;
        }
      });
  };
  const onError = (error: any) => {
    let errorList: { message: string; ref: HTMLElement }[] =
      Object.values(error);
    alert(errorList[0].message);
    window.scrollTo(0, errorList[0].ref.offsetTop - 150);
    errorList[0].ref.focus();
  };
  const { t } = useTranslation();

  return (
    <div className={`${styles.container} ${!isDesktop && styles.isMobile}`}>
      {isDesktop && <Header />}
      {!isDesktop && (
        <div className={styles.backBtn} onClick={() => navigate(-1)}>
          <img src={loginBack} alt="backBtn" />
        </div>
      )}
      <div className={styles.contentWrap}>
        <h2 className={styles.title}>{t('join.1')}</h2>
        <div className={styles.socialLoginWrap}>
          <div
            className={styles.facebookLoginWrap}
            onClick={() => {
              localStorage.setItem('rurl', redirectURL || '/');
              window.location.href = FACEBOOK_AUTH_URL;
            }}
          >
            <img src={facebook} alt="facebook" />
            <span>{t('join.51')}</span>
          </div>
          <div
            className={styles.appleLoginWrap}
            onClick={() => {
              localStorage.setItem('rurl', redirectURL || '/');
              handleAppleLogin();
            }}
            // onClick={handleAppleLogin}
          >
            <img src={apple} alt="apple" />
            <span>{t('join.53')}</span>
          </div>
          <div
            className={styles.googleLoginWrap}
            onClick={() => {
              localStorage.setItem('rurl', redirectURL || '/');
              window.location.href = GOOGLE_AUTH_URL;
            }}
          >
            <img src={google} alt="google" />
            <span>{t('join.52')}</span>
          </div>
          <div className={styles.or}>
            <div></div>
            <span>OR</span>
            <div></div>
          </div>
        </div>
        <form
          onSubmit={handleSubmit(onSubmit, onError)}
          className={styles.joinForm}
        >
          <div className={styles.id}>
            <span>{t('join.2')}</span>
            <div className={styles.idInputWrap}>
              <input
                type="text"
                // placeholder="영문, 숫자 4자 이상"
                {...register('id', {
                  value: '',
                  required: {
                    value: true,
                    message: t('join.27'),
                  },
                  pattern: {
                    value: idRegex,
                    message: t('join.28'),
                  },
                  onChange: () => {
                    setValue('idCheck', false);
                  },
                })}
              />
              <div
                className={styles.idCheck}
                onClick={handleIdCheck}
                {...register('idCheck', {
                  value: false,
                  validate: () =>
                    watch().idCheck !== true ? t('join.29')! : true,
                })}
              >
                {t('join.3')}
              </div>
            </div>
          </div>
          <div className={styles.pw}>
            <span>{t('join.4')}</span>
            <input
              type="password"
              {...register('pw', {
                value: '',
                required: t('join.30')!,
                pattern: {
                  value: passwordRegex,
                  message: t('join.31'),
                },
              })}
              // placeholder="비밀번호 입력"
            />
          </div>
          <div className={styles.pwCheck}>
            <span>{t('join.5')}</span>
            <input
              type="password"
              {...register('pwCheck', {
                value: '',
                validate: () =>
                  watch().pw !== watch().pwCheck ? t('join.32')! : true,
              })}
              // placeholder="비밀번호 재입력"
            />
          </div>
          <div className={styles.name}>
            <span>{t('join.6')}</span>
            <input
              type="text"
              {...register('name', {
                value: '',
                required: t('join.33')!,
                pattern: {
                  value: nameRegex,
                  message: t('join.34'),
                },
              })}
              placeholder={t('join.6')!}
            />
          </div>
          <div className={styles.gender}>
            <span>{t('join.48')}</span>
            <div className={styles.genderWrapper}>
              <label
                className={watch('gender') === 'male' ? styles.active : ''}
              >
                <input
                  type="radio"
                  value="male"
                  {...register('gender', {
                    required: t('join.genderRequired')!,
                  })}
                />
                <span className={styles.radioIcon}></span>
                {t('join.57')}
              </label>
              <label
                className={watch('gender') === 'female' ? styles.active : ''}
              >
                <input
                  type="radio"
                  value="female"
                  {...register('gender', {
                    required: t('join.50')!,
                  })}
                />
                <span className={styles.radioIcon}></span>
                {t('join.58')}
              </label>
              <label
                className={watch('gender') === 'others' ? styles.active : ''}
              >
                <input
                  type="radio"
                  value="others"
                  {...register('gender', {
                    required: t('join.50')!,
                  })}
                />
                <span className={styles.radioIcon}></span>
                {t('join.59')}
              </label>
            </div>
          </div>
          <div className={styles.birthDate}>
            <span>{t('join.55')}</span>
            <input
              type="text"
              {...register('birthDate', {
                required: 'Date of birth is required',
                pattern: {
                  value: /^\d{8}$/,
                  message: 'Please enter a valid date in YYYYMMDD format',
                },
                onChange: (e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  if (value.length === 8) {
                    const birthYear = value.substring(0, 4);
                    const birthDay = value.substring(4);
                    setValue('birthYear', birthYear);
                    setValue('birthDay', birthDay);
                  }
                },
              })}
              maxLength={8}
              placeholder="YYYYMMDD"
            />
          </div>

          <div className={styles.tel}>
            <span>{t('join.7')}</span>
            <div className={styles.telInputWrap}>
              <input
                type="text"
                // placeholder="전화번호 입력"
                {...register('tel', {
                  value: '',
                  required: t('join.35')!,
                  validate: () =>
                    watch().tel.length < 10 || isNaN(watch().tel)
                      ? t('join.36')!
                      : true,
                  onChange: (e) => {
                    const value = e.currentTarget.value;
                    if (isNaN(Number(value)) && value !== '+')
                      setValue(
                        'tel',
                        watch().tel.slice(0, watch().tel.length - 1),
                      );
                  },
                })}
              />
            </div>
            {/* <p>주문 등과 관련된 중요한 문자가 발송됩니다.</p> */}
          </div>
          <div className={styles.email}>
            <span>{t('join.8')}</span>
            <div className={styles.emailInputWrap}>
              <input
                type="text"
                {...register('email1', {
                  value: '',
                  required: t('join.37')!,
                })}
              />
              <span>@</span>
              <div>
                <div className={styles.customSelect}>
                  <input
                    type="text"
                    placeholder={`${t('join.9')}`}
                    {...register('email2', {
                      value: '',
                      onChange: (e) => {
                        setValue('emailCheck', false);
                      },
                    })}
                  />
                  <select
                    {...register('emailSelect', {
                      onChange: (e) => {
                        if (e.currentTarget.value == 'directly') {
                          setEmailDirectly(true);
                          setValue('email2', '');
                        } else setValue('email2', e.currentTarget.value);
                        setValue('emailCheck', false);
                      },
                    })}
                    style={{ display: emailDirectly ? 'none' : '' }}
                  >
                    <option disabled selected>
                      {t('join.10')}
                    </option>
                    <option value="gmail.com">gmail.com</option>
                    <option value="hotmail.com">hotmail.com</option>
                    <option value="outlook.com">outlook.com</option>
                    <option value="icloud.com">icloud.com</option>
                    <option value="directly">{t('join.9')}</option>
                  </select>
                  <img
                    src={selectOpen}
                    alt="selectOpen"
                    style={{
                      display: emailDirectly ? 'none' : '',
                      pointerEvents: 'none',
                    }}
                  />
                  <img
                    src={inputCancel}
                    alt="inputCancel"
                    style={{ display: !emailDirectly ? 'none' : '' }}
                    onClick={() => {
                      setEmailDirectly(false);
                      setValue('emailCheck', false);
                      setValue('email2', '');
                    }}
                  />
                </div>
              </div>
            </div>
            <div
              className={styles.emailCheck}
              onClick={handleEmailCheck}
              {...register('emailCheck', {
                value: false,
                validate: () =>
                  watch().emailCheck !== true ? t('join.38')! : true,
              })}
            >
              {t('join.3')}
            </div>
          </div>
          <div
            className={styles.marketing}
            {...register('marketing', {
              value: [false, false, false],
              validate: () =>
                !watch().marketing.includes(true) ? t('join.39')! : true,
            })}
          >
            <span>{t('join.11')}</span>
            <ul>
              <li onClick={() => marketingAgree(0)}>
                <div
                  className={`${styles.checkbox} ${
                    watch().marketing && watch().marketing[0] ? styles.hit : ''
                  }`}
                ></div>
                <span>SNS</span>
              </li>
              <li onClick={() => marketingAgree(1)}>
                <div
                  className={`${styles.checkbox} ${
                    watch().marketing && watch().marketing[1] ? styles.hit : ''
                  }`}
                ></div>
                <span>{t('join.12')}</span>
              </li>
              <li onClick={() => marketingAgree(2)}>
                <div
                  className={`${styles.checkbox} ${
                    watch().marketing && watch().marketing[2] ? styles.hit : ''
                  }`}
                ></div>
                <span>{t('join.13')}</span>
              </li>
            </ul>
            {/* <p>신상품 소식, 이벤트 안내, 다양한 혜택이 제공됩니다.</p> */}
          </div>
          <div
            className={styles.agreement}
            {...register('agreement', {
              value: [false, false, false, false],
              validate: () =>
                watch().agreement.slice(0, 3).includes(false)
                  ? t('join.40')!
                  : true,
            })}
          >
            <h3
              onClick={() => {
                setValue(
                  'agreement',
                  (() => {
                    let prev = watch().agreement;
                    if (prev.includes(false)) return [true, true, true, true];
                    else return [false, false, false, false];
                  })(),
                );
              }}
            >
              <div
                className={`${styles.customCheckbox} ${
                  watch().agreement && !watch().agreement.includes(false)
                    ? styles.hit
                    : ''
                }`}
              ></div>
              <span>{t('join.16')}</span>
            </h3>
            <ul className={styles.agreementList}>
              <li>
                <div
                  className={styles.left}
                  onClick={() => {
                    setValue(
                      'agreement',
                      (() => {
                        let prev = watch().agreement;
                        prev[0] = !prev[0];
                        return [...prev];
                      })(),
                    );
                  }}
                >
                  <div
                    className={`${styles.customCheckbox} ${
                      watch().agreement && watch().agreement[0]
                        ? styles.hit
                        : ''
                    }`}
                  ></div>
                  <span className={styles.title}>{t('join.18')}</span>
                </div>
                <span
                  onClick={() => {
                    setAgreementModalOpen(true);
                    setAgreementModalType(0);
                  }}
                >
                  {t('join.17')}
                </span>
              </li>
              <li>
                <div
                  className={styles.left}
                  onClick={() => {
                    setValue(
                      'agreement',
                      (() => {
                        let prev = watch().agreement;
                        prev[1] = !prev[1];
                        return [...prev];
                      })(),
                    );
                  }}
                >
                  <div
                    className={`${styles.customCheckbox} ${
                      watch().agreement && watch().agreement[1]
                        ? styles.hit
                        : ''
                    }`}
                  ></div>
                  <span className={styles.title}>{t('join.20')}</span>
                </div>
                <span
                  onClick={() => {
                    setAgreementModalOpen(true);
                    setAgreementModalType(1);
                  }}
                >
                  {t('join.17')}
                </span>
              </li>
              <li>
                <div
                  className={styles.left}
                  onClick={() => {
                    setValue(
                      'agreement',
                      (() => {
                        let prev = watch().agreement;
                        prev[2] = !prev[2];
                        return [...prev];
                      })(),
                    );
                  }}
                >
                  <div
                    className={`${styles.customCheckbox} ${
                      watch().agreement && watch().agreement[2]
                        ? styles.hit
                        : ''
                    }`}
                  ></div>
                  <span className={styles.title}>{t('join.22')}</span>
                </div>
                <span
                  onClick={() => {
                    setAgreementModalOpen(true);
                    setAgreementModalType(2);
                  }}
                >
                  {t('join.17')}
                </span>
              </li>
              <li>
                <div
                  className={styles.left}
                  onClick={() => {
                    setValue(
                      'agreement',
                      (() => {
                        let prev = watch().agreement;
                        prev[3] = !prev[3];
                        return [...prev];
                      })(),
                    );
                  }}
                >
                  <div
                    className={`${styles.customCheckbox} ${
                      watch().agreement && watch().agreement[3]
                        ? styles.hit
                        : ''
                    }`}
                  ></div>
                  <span className={styles.title}>{t('join.24')}</span>
                </div>
                <span
                  onClick={() => {
                    setAgreementModalOpen(true);
                    setAgreementModalType(3);
                  }}
                >
                  {t('join.17')}
                </span>
              </li>
            </ul>
          </div>
          <button className={styles.submitBtn}>{t('join.14')}</button>
        </form>
      </div>
      {agreementModalOpen && (
        <JoinAgreementModal
          type={agreementModalType}
          isOpen={setAgreementModalOpen}
        />
      )}
    </div>
  );
}
export default Join;
